import { selector } from 'recoil';

import { modalInfoState, rightSideBarFullState, rightSideBarTabState, themeTypeState } from './atoms';
import { THEME_TYPE } from 'constants/themeConstants';
import lightTheme from 'styles/themes/lightTheme';
import darkTheme from 'styles/themes/darkTheme';

export const themeSelector = selector({
  key: 'themeSelector',
  get: ({ get }) => {
    const themeType = get(themeTypeState);

    if (themeType === THEME_TYPE.DARK) return darkTheme;
    return lightTheme;
  },
});

export const modalSelector = selector({
  key: 'modalSelector',
  get: ({ get }) => {
    const modalInfo = get(modalInfoState);

    return Object.keys(modalInfo).map((key) => ({
      key,
      component: modalInfo[key],
    }));
  },
});

export const rightSideBarFullSelector = selector({
  key: 'rightSideBarFullSelector',
  get: ({ get }) => {
    const isRightSideBarFull = get(rightSideBarFullState);
    const selectedTab = get(rightSideBarTabState);

    return Boolean(selectedTab && isRightSideBarFull);
  },
});
